import React from 'react';
import './Class.css';
import spokenEnglish from '../../Images/Bolo Bindass.png';
import {Helmet} from "react-helmet";

const BoloBindassComponent = () => (
  <div className="explore-container">
    <Helmet>
                <meta charSet="utf-8" />
                <title>Bolo Bindass - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
    {/* Back Button */}
    <button className="back-button" onClick={() => window.history.back()}>
      ← Back
    </button>

    {/* Lakshya Card (Right Side, Above Header) */}
    <div className="lakshya-card">
      <img
        src={spokenEnglish}
        loading="lazy"
        alt="bolo-bindass"
        className="lakshya-image"
      />
      <div className="course-details">
  
  <p className="pricing">💼 Fees for Full Course: ₹ 2999/-</p>
  <a href="https://rzp.io/rzp/BoloBindass" target="_blank" rel="noopener noreferrer">
    <button className="buy-button">Buy Now</button>
  </a>
</div>

    </div>

    {/* Lakshya Header (Full Width) */}
    <div className="lakshya-header">
      <div className="lakshya-header-content">
        <h2 className="lakshya-title">Bolo <span className='highlight'>Bindass</span> (Class-<span className='highlight'>4-8</span>)</h2>
      </div>
    </div>

    {/* Batch Details Section */}
    <div className="batch-details">
      <h3>Description</h3>
      <ul>
  <li><strong>1️⃣Daily Conversations</strong>  
    <ul>
      <li>🗣️Practice speaking on everyday topics like hobbies, school, and current events.
      </li>
    </ul>
  </li>
  <li><strong>2️⃣Vocabulary Building</strong>  
    <ul>
      <li>💬Expand your vocabulary to express thoughts more clearly and confidently.
      </li>
    </ul>
  </li>
  <li><strong>3️⃣Pronunciation & Accent</strong>  
    <ul>
      <li>📝Improve pronunciation, fluency, and understanding of English accent variations.
      </li>
    </ul>
  </li>
  <li><strong>4️⃣Confidence-Boosting Activities</strong>  
    <ul>
      <li>🎯Activities like group discussions, debates, and public speaking exercises to overcome shyness and fear.
      </li>
    </ul>
  </li>
  <li><strong>5️⃣Grammar in Context</strong>  
    <ul>
      <li>📚Learn English grammar through real-life examples to help with sentence construction and clarity.</li>
    </ul>
  </li>
  <li><strong>6️⃣Expert-Led Sessions</strong>  
    <ul>
      <li>🧑‍🏫 Work with expert tutors who provide personalized coaching and constructive feedback.
      .</li>
    </ul>
  </li>
  <li><strong>7️⃣Regular Practice & Feedback</strong>  
    <ul>
      <li>🏆Regular assignments and feedback ensure continuous improvement.
      </li>
    </ul>
  </li>
  <li><strong>8️⃣Interactive Learning</strong>  
    <ul>
      <li>🎮Engaging games, role-playing, and fun quizzes to encourage active participation.
      </li>
    </ul>
  </li>
  <li><strong>9️⃣24/7 Doubt Solving</strong>  
    <ul>
      <li>🧑‍💻Get help anytime with your doubts through 24/7 doubt-solving support.
      </li>
    </ul>
  </li>
  <li><strong>📩 Have Questions?</strong>  
    <ul>
      <li>Reach out to us at <a href="mailto:support@ottertutors.com">support@ottertutors.com</a></li>
    </ul>
  </li>
  <br/>
  <li><strong>🚀 Join <span className='highlight1'>'Bolo Bindass'</span> Take the first step towards academic success!</strong>  
  </li>
</ul>


    </div>

    {/* FAQ Section */}
    <div className="faq-section">
      <h2>FAQs</h2>
      <p style={{ textAlign: 'center' }}>
  Here are some of the frequently asked questions:
</p>
<div className="faq-grid">
  <div className="faq-item">
    🎯
    <div>
      <h3>Who Should Join This Batch?</h3>
      <p>
        🎓 Class 4-8 students who want to improve their spoken English and gain confidence in everyday conversations and public speaking.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Where Will the Classes Be Held?</h3>
      <p>
        💻 Classes will be conducted on Zoom, and links will be shared via WhatsApp groups for easy access.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>What Is the Duration of Each Class?</h3>
      <p>
        ⏰ Each class will be 1 hour long, with interactive lessons and activities designed to improve communication skills.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Can I Get Help If I Have Doubts?</h3>
      <p>
        💬 24/7 doubt-solving support is available, so students can reach out anytime for assistance with their learning.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>How Will My Child’s Progress Be Tracked?</h3>
      <p>
        📈 Regular assessments and feedback sessions will help track improvement, with personalized coaching provided to focus on areas that need attention.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Will My Child Learn to Speak in Front of an Audience?</h3>
      <p>
        🎤 Yes! The course includes public speaking exercises, where students will practice speaking in front of an audience, boosting their confidence for school presentations or future events.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>What If My Child Misses a Class?</h3>
      <p>
        📼 Don’t worry! All classes are recorded, so your child can catch up with missed content at any time.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>How Is This Course Different from Regular English Classes?</h3>
      <p>
        📚 Unlike regular English classes that focus on reading and writing, this course emphasizes spoken English, pronunciation, and building confidence through interactive learning and practical application.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Can I Get a Refund After Batch Purchase?</h3>
      <p>
        💡 Refunds are not available after batch purchase, as we invest heavily in providing top-quality lessons and infrastructure. Please make a thoughtful decision before enrolling.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>What Skills Will My Child Gain from This Course?</h3>
      <p>
        🧠 Your child will gain confidence in speaking, fluency in English, and the ability to communicate effectively in school, social settings, and future professional opportunities.
      </p>
    </div>
  </div>
</div>
</div>
  </div>
);

export default BoloBindassComponent;
